<template>
    <div class="container">
        <div class="header-row">
            <div class="header-title">
                Проходите обучение и отмечайте прокаченные навыки
            </div>
            <div
                v-for="(variant, index) in variants"
                :key="index"
                class="header-label"
            >
                {{ variant }}
            </div>
        </div>
        <HardCompetenceItem
            v-for="item in items"
            :key="item.id"
            :item="item"
            class="competence-item"
        />
    </div>
</template>

<script>
import HardCompetenceItem from "./HardCompetenceItem";

export default {
    name: "HardCompetences",

    components: {
        HardCompetenceItem,
    },

    props: {
        items: {
            type: Array,
            default: () => [],
        },
        variants: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.header {
    &-row {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 24px;

        @include on-xs {
            margin-bottom: 8px;
        }
    }

    &-title {
        flex: 1 1 70%;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #2A2626;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        @include on-xs {
            flex: 1 1 50%;
            opacity: 0;
        }
    }

    &-label {
        flex: 0 0 15%;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #98A0A9;
        white-space: nowrap;

        @include on-xs {
            flex: 0 0 25%;
            font-size: 14px;
        }
    }
}
</style>